<template>
  <div>
    <div class="content-top idm-player" id="content_top">
      <!--div class="main-title">Preview your video</div-->
      <!--p class="main-second-title"></p-->

      <div class="player-block" id="preview">
        <div class="player-box horizontal">
          <div id="idm-player"></div>

          <div class="action-btn">

            <a class="btn-cfa btn-cfa-mob" @click="back"><span>Back to Video Creator</span></a>

            <a class="btn-cfa btn-copy" @click="clipboard" :class="{done:copiedTooltip}">
              <div class="btn-icon">
                <img src="@/assets/img/download.png">
              </div>
              <span>Copy Video Link for Sharing</span>
              <div class="tooltip">
                <span>Copied</span>
              </div>
            </a>

          </div>


        </div>

        <div v-if="0" class="player-info">
          <!--p>Preview the video. Click the "Back to Video Creator" button if you want to make any adjustments. </p><p>You can also copy the link to this video below and embed it into your email to the customer. </p-->
        </div>

    <div class="btn-back">
      <a class="btn-cfa" @click="back"><span>Back to Video Creator</span></a>

      
    </div>

    
      </div>

    

    </div>

  </div>
</template>

<script>
export default {
  name: 'PreviewComp',
  data:()=>{
    return {
      player_options:{
        size: "wide",
        analytics_env: "us",
        ratio: "1:1",
        autoplay: false,
        mute: false,
        idm_logo: false,
        fade_control_bar: true,
        minimal_version: true,
        toolbar_position: "low",
        extension: "m3u8",
        interactive: true,
        show_customise: false,
        share_button: {
          download: true,
          copy: false,
          mail: false,
          whatsapp: false,
          facebook: false,
          twitter: false,
          copy_thumb: false
        },
        /*close_captions: [
          {
            "srclang": "en",
            "label": "English"
          }
        ],*/
        cta_analytics: [["idm-cta-btn1", "Contact your Implementation Consultant"]],
      },
      copiedTooltip:false,
      copyLink:null,
    }
  },
  props: {
    videoData: Object
  },
  methods:{
    clipboard(){
      this.$clipboard(this.copyLink)
      this.copiedTooltip = true;
      setTimeout(() => {this.copiedTooltip = false;},2000);
    },
    back(){
      this.$emit('back')
    }
  },
  mounted(){
    this.player_options.src = this.videoData.res.output.video[0].links.url

    this.copyLink = this.player_options.src.replace('.m3u8', '').split('idomoo.com/')[1]
    //this.copyLink = window.location.origin + window.location.pathname + '?id='+this.copyLink + '&cl=' + this.videoData.cl
    this.copyLink = window.location.origin + window.location.pathname + '?id='+this.copyLink

    setTimeout(()=>{
      window.idmPlayerCreate(this.player_options, "idm-player");
    }, 100);
  },
  beforeUnmount() {
    window["idm-player"].dispose()
  }
}
</script>

<style scoped>
.idm-lp .player-box {
  width: 40%;
}

.idm-lp a.btn-cfa.btn-cfa-mob {
  display: none;
}

.main-title{
  max-width: 640px;
  margin: 15px auto 10px;
  text-align: center;
  padding: 0 10px;
}

.main-second-title{
  max-width: 640px;
  margin: 15px auto 30px;
  text-align: center;
  font-size: 18px;
  padding: 0 20px;
}
.btn-cfa{
  cursor: pointer;
  position: relative;
}

.btn-back {
  text-align: center;
  width: 90%;
  padding-top: 50px;
  margin: 0 auto;
}


.btn-back .btn-cfa {
  padding: 8px 50px;
  max-width: 382px;
   margin: 0 auto;
  min-width: 150px;
  height: 40px;
   box-sizing: border-box;
}
.btn-cfa>*{
  transition: none;
}
.btn-cfa .tooltip{
  display: none;
}
.btn-cfa.done span{
  color:transparent;
}
.btn-cfa.done .tooltip{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
}
.btn-cfa.done .tooltip span{
  color:#fff;
}

.btn-icon {
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-right: 10px;
}


a.btn-copy {
  align-items: center;
  display: flex !important;
  justify-content: center;
}


.action-btn{
  margin: 20px auto 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}



.btn-copy img {
  max-height: 100%;
}

.btn-copy img.scr-img  {
  border: 1px solid #000;
}

.btn-back {
    padding-top: 20px;
  }




/*@media (max-height: 825px) {*/

  .idm-lp .btn-back a.btn-cfa {
    display: none;
  }

  .idm-lp a.btn-cfa.btn-cfa-mob {
    display: block;
    max-width: fit-content;
  } 
/*}*/

@media (max-width: 1400px) {
  .player-info {
      order: 3;
    }

    .idm-lp .btn-back a.btn-cfa {
      display: block;
    }
    
    .idm-lp a.btn-cfa.btn-cfa-mob {
      display: none;
    }

    .idm-lp .player-box {
      width: 100%;
      margin: 0 auto !important;
    }

    .btn-back {
      padding-bottom: 30px;
      padding-top: 30px;
    }

}

@media (max-width: 767px) {
  .player-info {
    padding-top: 25px;
    text-align: center;
  }

  .player-info p {
    text-align: left;
    font-size: 14px;
  }

  .player-info p.tittle-img  {
    margin: 0 auto;
  }
}

</style>

<style>

#preview .vjs-control-bar .vjs-control.exception-menu-button {
  display: block !important;
}

/*#idm-player .vjs-control-bar .vjs-control.moo-button {
  display: none !important;
}*/

#preview .vjs-control-bar .vjs-playback-speed-control,
#preview .vjs-control-bar .vjs-fullscreen-control,
#preview .vjs-control-bar .vjs-captions-button.simple,
#preview .vjs-control-bar .idm-share-button {
  display: none !important;
}
</style>




<!--script>
  /**
   * @return query string parameter array
   */
  function getQSParamNew() {
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = pair[1];
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [query_string[pair[0]], pair[1]];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(pair[1]);
      }
    }
    return query_string;
  }

  /**
   * Get vedio path from URL
   */

  var urlObject = getQSParamNew();
  var vedioUrl = "";

  if (urlObject) {
    if (typeof urlObject.url != "undefined" && urlObject.url != "") {
      vedioUrl = decodeURIComponent(urlObject.url);
    } else {
      vedioUrl =
        "https://s3.amazonaws.com/web-assets.idomoo.com/production/demo_video.mp4";
    }
  } else {
    vedioUrl =
      "https://s3.amazonaws.com/web-assets.idomoo.com/production/demo_video.mp4";
  }



  var interactiveEvents =
    document.getElementById("interactive").value == 1 ? true : false;
  var player_options = null;
  setTimeout(function () {
    player_options = {
      build_url: "https://liv.idomoo.com/",
      size: "wide",
      analytics_env: "us",
      ratio: "1:1",
      autoplay: false,
      mute: false,
      idm_logo: false,
      fade_control_bar: true,
      toolbar_position: "low",
      share_button: false,
      extension: "m3u8",
      interactive: interactiveEvents,
      close_captions: [
        {
          "srclang": "en",
          "label": "English"
        }
      ],
      cta_analytics: [["idm-cta-btn1", "Meet With Your Account Manager"]],
    };
    idmPlayerCreate(player_options, "idm-player");

    var player = window["idm-player"];

    player.ready(function () {
      document.querySelector('#idomoo_new_player').removeAttribute('aria-expanded');

      /* mob iOS */

      const devices = new RegExp('webOS|iPhone|iPad|iPod', "i");
      if (devices.test(navigator.userAgent) || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1)) {
        document.querySelector('#transcript-text-box').style.height = "auto";
        document.querySelector('video').textTracks[0].cues[2].line = -5;
      }

    })

  }, 100);
</script-->
